import React from "react";
import Skeleton from "react-loading-skeleton";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";

function DemographicsSkeleton() {
  return (
    <DashboardCard2 rawChildren>
      <dl className="tw:grid tw:grid-cols-[repeat(auto-fill,minmax(200px,1fr))] tw:gap-x-7 tw:gap-y-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={`demographics-${i}`}>
            <Skeleton className="tw:mb-1" height={12} width={80} />
            <Skeleton height={16} width={140} />
          </div>
        ))}
      </dl>
    </DashboardCard2>
  );
}

function CareTeamSkeleton() {
  return (
    <DashboardCard2 title={<Skeleton width={100} />}>
      <div className="tw:grid tw:grid-cols-3 tw:gap-7.5">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton height={100} key={`care-team-${i}`} />
        ))}
      </div>
    </DashboardCard2>
  );
}

function CareGoalsSkeleton() {
  return (
    <DashboardCard2 title={<Skeleton width={300} />}>
      <div className="tw:flex tw:gap-7.5">
        {Array.from({ length: 2 }).map((_, i) => (
          <div className="tw:flex tw:w-1/2 tw:flex-col tw:gap-2" key={`care-goals-${i}`}>
            <Skeleton height={14} width={140} />
            <div className="tw:flex tw:flex-col tw:gap-1">
              <Skeleton height={12} width={100} />
              {Array.from({ length: 4 }).map((_, j) => (
                <Skeleton height={12} key={`care-goal-${j}`} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </DashboardCard2>
  );
}

export function MemberProfileCarePlanSkeleton() {
  return (
    <>
      <DemographicsSkeleton />
      <CareTeamSkeleton />
      <CareGoalsSkeleton />
    </>
  );
}
